var _defs, _path, _path2, _path3, _circle, _circle2, _circle3, _circle4, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvestigation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 440 330",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-.033%",
    y1: "50%",
    x2: "100.027%",
    y2: "50%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECEFF1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.4,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100.221%",
    y1: "50%",
    x2: "-.095%",
    y2: "50%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D8D9D7",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    offset: "23%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: ".032%",
    y1: "49.882%",
    x2: "99.996%",
    y2: "49.882%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#191F35",
    offset: "30%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#223256",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Graphic-elements-/-Icons-/-Rich-icons-/-Investigation",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Asset-4",
    transform: "translate(59)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M317.195 300.878l-.592-.902-.65-.875-.69-.846-.762-.804-2.834-2.905-2.905-2.905-2.906-2.891-2.905-2.905-19.038-19.039-19.053-19.038-19.038-19.039-19.053-19.038-.324.324-.339.325-.324.338-.338.325-2.82-2.82-2.821-2.821-2.82-2.821-2.821-2.82a118.264 118.264 0 0010.323-15.965 118.687 118.687 0 0012.55-36.483A119.491 119.491 0 0095.532 10.55 118.814 118.814 0 0053.04 28.318a120.323 120.323 0 00-17.628 14.427l.112-.155.113-.141.099-.141.113-.141a120.718 120.718 0 00-14.935 17.755A119.153 119.153 0 009.632 80.385a117.376 117.376 0 00-7.136 22.662 119.547 119.547 0 00137.02 142.098 117.954 117.954 0 0018.969-4.851 119.012 119.012 0 0033.62-18.136l2.82 2.82 2.75 2.82 2.821 2.821 2.75 2.82-.733.734-.734.733-.733.72-.733.733 21.845 21.718L244.1 280.02l21.958 21.943 21.944 21.944a18.813 18.813 0 0018.587 4.682l.423-.127.437-.155.423-.155.423-.17c.568-.225 1.123-.479 1.664-.761.549-.285 1.081-.6 1.594-.945a19.1 19.1 0 001.523-1.114c.494-.395.959-.832 1.41-1.284a18.686 18.686 0 005.02-17.29 18.333 18.333 0 00-2.312-5.71z",
    id: "Path",
    fill: "#003A5D",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M223.089 118.151c-.051-50.862-38.62-93.418-89.232-98.456-50.613-5.038-96.814 29.08-106.89 78.934-10.076 49.854 19.248 99.237 67.844 114.25 48.596 15.014 100.664-9.222 120.465-56.073a98.72 98.72 0 007.813-38.655z",
    id: "Path",
    fill: "#0099DA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M117.742 29.7a99.197 99.197 0 0199.325 99.282 101.37 101.37 0 01-.691 11.776 97.463 97.463 0 01-2.017 11.282 99.804 99.804 0 01-3.272 10.873 101.538 101.538 0 01-4.442 10.323 100.128 100.128 0 006.205-11.818 98.93 98.93 0 007.46-26.033c.658-4.644.987-9.328.987-14.018 0-36.154-19.651-69.45-51.303-86.922-31.653-17.471-70.3-16.356-100.891 2.913A99.635 99.635 0 0033.14 77.056 99.113 99.113 0 01117.756 29.7h-.014z",
    id: "Path",
    fill: "#0096D6",
    opacity: 0.3,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.995 188.368l-70.23-70.217L53.59 47.95s7.206-12.918 23.974-22.212c16.768-9.293 43.154-14.977 81.301-.493 38.148 14.483 59.57 44.14 65.112 75.744 5.542 31.604-4.71 65.14-29.982 87.38z",
    id: "Path",
    fill: "url(#linearGradient-1)",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M273.167 248.205l-14.103-14.102L244.962 220l-14.103-14.103-14.103-14.102a122.946 122.946 0 0010.295-15.964 120.14 120.14 0 007.714-17.586c18.1-52.526-2.455-110.594-49.571-140.034-47.116-29.44-108.317-22.457-147.591 16.84-39.274 39.296-46.221 100.501-16.755 147.6 29.467 47.1 87.546 67.622 140.062 49.491a117.7 117.7 0 0017.614-7.756 118.983 118.983 0 0016.091-10.365l14.103 14.102 14.103 14.103 14.102 14.102 14.103 14.103 5.542-5.557 5.556-5.542 5.557-5.556 5.486-5.57zm-151.264-34.65c-38.114.047-72.494-22.893-87.082-58.104-14.587-35.211-6.504-75.744 20.475-102.665A94.896 94.896 0 0185.25 32.535a94.487 94.487 0 0173.333 0 94.699 94.699 0 0150.135 50.162 94.233 94.233 0 01-86.83 130.858h.015z",
    id: "Shape",
    fill: "#D2D8DC"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "white",
    cx: 120.972,
    cy: 120.944,
    r: 57.242
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#356075",
    cx: 120.915,
    cy: 121.24,
    r: 35.242
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#023852",
    cx: 120.915,
    cy: 121.24,
    r: 19.673
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "white",
    cx: 141.956,
    cy: 102.864,
    r: 11.212
  })), /*#__PURE__*/React.createElement("path", {
    d: "M216.756 191.795s-.69.917-1.89 2.426a131.135 131.135 0 01-4.978 5.894c-2.073 2.313-4.484 4.866-7.05 7.291a64.872 64.872 0 01-8.237 6.615l5.641 5.74 5.712 5.739 5.725 5.74 5.642 5.74 5.471-5.642 5.472-5.64 5.472-5.642 5.472-5.64-5.641-5.642-5.641-5.64-5.641-5.712-5.529-5.627z",
    id: "Path",
    fill: "url(#linearGradient-2)",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M316.941 315.785a18.7 18.7 0 000-26.485l-21.944-21.944-21.957-21.971-21.944-21.944-21.958-21.944-6.614 6.615-6.628 6.628-6.628 6.614-6.614 6.628 21.943 21.93 21.958 21.943L268.5 293.8l22.014 21.986a18.517 18.517 0 006.19 4.118 18.7 18.7 0 0020.294-4.118h-.056z",
    id: "Path",
    fill: "#003A5D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M316.941 289.3l-2.905-2.905-2.905-2.933-2.891-2.821-2.905-2.905a18.7 18.7 0 010 26.485 18.714 18.714 0 01-6.206 4.117 18.827 18.827 0 01-14.102 0 18.714 18.714 0 01-6.205-4.117l2.905 2.905 2.905 2.905 2.905 2.89 2.905 2.906a18.517 18.517 0 006.191 4.118 18.728 18.728 0 0020.294-30.603l.014-.042z",
    id: "Path",
    fill: "url(#linearGradient-3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestigation);
export default __webpack_public_path__ + "static/media/investigation.7ee5f7ef63be1751afbf4beb076d12ad.svg";
export { ForwardRef as ReactComponent };